import React from 'react';
import PropTypes from 'prop-types';
import PriorityIcon from "../../../../../../core/gd-components/priority/priority-icon/priority-icon";

// extends React.Component is required because of reference in parent
export default class FieldPriority_PopoverOption extends React.Component<any,any> {

    static propTypes = {
        option: PropTypes.object,

        isHighlighted: PropTypes.bool,
        isSelected: PropTypes.bool,

        onClick: PropTypes.func,
    }

    onClick = () => {this.props.onClick(this.props.option)}

    render() {
        const classes = Classes('option', {
            'highlighted': this.props.isHighlighted
        });

        const valueClass = Classes('label', {
            bold: this.props.isSelected
        });

        return (
            <div className={classes} onClick={this.onClick}>
                <PriorityIcon className="fl-no-shrink m-r-10" priority={this.props.option.value}/>
                <div className={valueClass}>{this.props.option.label}</div>
            </div>
        );
    }
}